"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var dayjs_1 = __importDefault(require("dayjs"));
var isBetween_1 = __importDefault(require("dayjs/plugin/isBetween"));
var lodash_throttle_1 = __importDefault(require("lodash.throttle"));
var types_1 = require("../../middleware/api/types");
var constants_1 = require("./constants");
var config_1 = __importStar(require("../../config"));
var api_1 = require("../../utils/api");
var changeChannel_1 = __importDefault(require("./queries/changeChannel"));
var getAllChannels_1 = __importDefault(require("./queries/getAllChannels"));
var getChannelSlots_1 = __importDefault(require("./queries/getChannelSlots"));
var selectors_1 = require("./selectors");
var getLinearSlotById_1 = __importDefault(require("./queries/getLinearSlotById"));
var actions_1 = require("../profilePreferences/actions");
exports.setSelectedCategoryId = actions_1.setSelectedCategoryId;
dayjs_1.default.extend(isBetween_1.default);
var SLOTS_UPDATE_FREQUENCY = 1000 * 60 * 10; // Currently 10 mins
exports.setChannelById = function (channels, override) {
    return toolkit_1.createAction(constants_1.SET_CHANNEL_BY_ID)({
        channels: channels,
        override: override,
    });
};
/**
 * Fetches all channels, channelGroups and WatchTvHome.channels from the API.
 *
 * This function initiates an API call to retrieve channel data, including
 * various optional parameters that control the details of the request.
 *
 * @param {AppId} appId - The application identifier used to scope the request.
 * @param {boolean} [needSlotDetail] - Indicates whether slot detail information is required.
 * @param {boolean} [needChannelImage] - Indicates whether channel images should be included in the response.
 * @param {LinearChannelAssetArgs} [linearChannelAssetArgs] - Additional arguments related to linear channel assets, such as device ID and encoding.
 * @param {boolean} [needWatchTvChannels] - Specifies if Watch TV channels should be included in the fetched data.
 */
exports.fetchAllChannels = function (appId, needSlotDetail, needChannelImage, linearChannelAssetArgs, needWatchTvChannels) {
    return api_1.createApiAction(constants_1.FETCH_ALL_CHANNELS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getAllChannels_1.default(!!needSlotDetail, !!needChannelImage, !!linearChannelAssetArgs, !!needWatchTvChannels),
            variables: {
                appId: appId,
                deviceId: linearChannelAssetArgs === null || linearChannelAssetArgs === void 0 ? void 0 : linearChannelAssetArgs.deviceId,
                encoding: linearChannelAssetArgs === null || linearChannelAssetArgs === void 0 ? void 0 : linearChannelAssetArgs.encoding,
            },
        },
        graphQL: true,
        method: types_1.HTTPMethod.GET,
        authenticated: true,
        onSuccess: function (dispatch, _a) {
            var payload = _a.payload;
            var _b;
            dispatch(exports.setChannelById(((_b = payload === null || payload === void 0 ? void 0 : payload.experience) === null || _b === void 0 ? void 0 : _b.channels) || [], true));
        },
        etagSelector: selectors_1.categoryByIdState,
    });
};
exports.clearSelectedChannelSlot = function () { return toolkit_1.createAction(constants_1.CLEAR_SELECTED_CHANNEL_SLOT)({}); };
exports.fetchSelectedChannelSlot = function (channelId, offset, needChannelDetail) {
    if (offset === void 0) { offset = 0; }
    if (needChannelDetail === void 0) { needChannelDetail = false; }
    var now = dayjs_1.default();
    var rewindRealTime = offset > 0 ? now.subtract(offset, 'second') : now;
    return api_1.createApiAction(constants_1.FETCH_SELECTED_CHANNEL_SLOT, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        authenticated: true,
        params: {
            query: getChannelSlots_1.default(needChannelDetail),
            variables: {
                channelId: channelId,
                at: offset > 0 ? rewindRealTime : null,
            },
        },
        graphQL: true,
        onSuccess: function (dispatch, _a) {
            var payload = _a.payload;
            if (needChannelDetail) {
                dispatch(exports.setChannelById([payload.linearChannel]));
            }
        },
    });
};
/**
 * calculate offset with a max offset of 2 hours, which is the most a user can go back.
 * currentTime / seekableEndTime can have weird values leading to excessive offset
 * values into the past and future.
 */
exports.calculateOffset = function (currentTime, seekableEndTime) {
    var MAX_OFFSET_SECONDS = 7200;
    var offset = seekableEndTime - currentTime;
    if (offset > MAX_OFFSET_SECONDS) {
        return MAX_OFFSET_SECONDS;
    }
    if (offset < 0) {
        return 0;
    }
    return offset;
};
exports.fetchSlotWithOffset = function (currentTime, seekableEndTime) { return function (dispatch, getState) {
    var channelId = selectors_1.selectedChannelId(getState());
    var offset = exports.calculateOffset(currentTime, seekableEndTime);
    if (channelId && Number.isFinite(offset)) {
        dispatch(exports.fetchSelectedChannelSlot(channelId, offset));
    }
}; };
var throttleFetchSlotWithOffset = lodash_throttle_1.default(function (dispatch, currentTime, seekableEndTime) {
    return dispatch(exports.fetchSlotWithOffset(currentTime, seekableEndTime));
}, SLOTS_UPDATE_FREQUENCY);
/**
 * Update slot when scrubbing playback or currentTime update
 * @param currentTime Playback current time or play head
 * @param seekableEndTime The newest linear endTime or LiveCurrentTime, different Player has different terms
 */
exports.updateNewSlot = function (currentTime, seekableEndTime) { return function (dispatch, getState) {
    var state = getState();
    var selectedSlot = selectors_1.selectedChannelSlot(state);
    var selectedSlotIsLoading = selectors_1.selectedChannelSlotIsLoading(state);
    if (selectedSlot) {
        var now = dayjs_1.default();
        var offset = seekableEndTime - currentTime;
        var realTime = offset > 0 ? now.subtract(offset, 'second') : now;
        var isBetweenCurrentSlotRange = realTime.isBetween(dayjs_1.default(selectedSlot.start), dayjs_1.default(selectedSlot.end));
        // If the current playback time is not between selected current Slot's time range
        if (!isBetweenCurrentSlotRange) {
            dispatch(exports.fetchSlotWithOffset(currentTime, seekableEndTime));
        }
    }
    // If selectedSlot is loaded but still have no slot return
    // Fetch next slot in 10 mins later to avoid too many request
    else if (!selectedSlotIsLoading) {
        throttleFetchSlotWithOffset(dispatch, currentTime, seekableEndTime);
    }
}; };
exports.setSelectedChannelId = function (channelId) {
    return toolkit_1.createAction(constants_1.SET_SELECTED_CHANNEL_ID)(channelId);
};
exports.saveRecentChannel = function (channelId, onRequestCB) {
    return api_1.createApiAction(constants_1.SAVE_RECENT_CHANNEL, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: changeChannel_1.default,
            variables: { channelId: channelId },
        },
        authenticated: true,
        graphQL: true,
        onRequest: function (dispatch) {
            onRequestCB === null || onRequestCB === void 0 ? void 0 : onRequestCB(dispatch);
        },
    });
};
exports.changeChannel = function (channelId) {
    return exports.saveRecentChannel(channelId, function (dispatch) { return dispatch(exports.setSelectedChannelId(channelId)); });
};
exports.fetchLinearSlotById = function (id) {
    return api_1.createApiAction(constants_1.FETCH_LINEAR_SLOT_BY_ID, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getLinearSlotById_1.default,
            variables: { id: id },
        },
        authenticated: true,
        graphQL: true,
    });
};
var setChannelSlotById = function (channelId, slot) {
    return toolkit_1.createAction(constants_1.SET_SLOT_FOR_CHANNEL_WITH_ID)({
        channels: [{ id: channelId, slot: slot }],
    });
};
var setSelectedSlot = function (slot) {
    return toolkit_1.createAction(constants_1.SET_SLOT_FOR_SELECTED_CHANNEL)({
        slot: slot,
    });
};
exports.setSlotForChannelWithId = function (channelId, slot) {
    return function (dispatch) {
        dispatch(setChannelSlotById(channelId, slot));
        dispatch(setSelectedSlot(slot));
    };
};
//# sourceMappingURL=actions.js.map